import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

export const Hero = () => (
  <section data-testid="hero-section" className="bg-white pt-32 sm:pt-40">
    <div className="mx-auto max-w-5xl px-5 text-center sm:px-6">
      <motion.p
        data-testid="hero-eyebrow"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="text-xs font-semibold uppercase tracking-[0.18em] text-[#86868b]"
      >
        CV Meranggi Jaya — Est. 1984 in Bali
      </motion.p>

      <motion.h1
        data-testid="hero-title"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="mt-5 text-4xl font-semibold leading-[1.08] tracking-tight text-[#1d1d1f] sm:text-6xl lg:text-7xl"
      >
        Garment manufacturing.
        <br />
        <span className="text-[#86868b]">Refined over four decades.</span>
      </motion.h1>

      <motion.p
        data-testid="hero-subtitle"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto mt-6 max-w-2xl text-lg font-normal leading-relaxed text-[#86868b] sm:text-xl"
      >
        Meranggi is the garment house of CV Meranggi Jaya — producing apparel in Gianyar, Bali, from first pattern to
        final packing.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        className="mt-8 flex items-center justify-center gap-6"
      >
        <a
          href="mailto:info@meranggi.com?subject=Production%20enquiry%20—%20Meranggi"
          data-testid="hero-cta-primary"
          className="rounded-full bg-[#0066cc] px-6 py-2.5 text-sm font-medium text-white transition-colors duration-200 hover:bg-[#0077ed]"
        >
          Contact the Factory
        </a>
        <button
          data-testid="hero-cta-secondary"
          onClick={() => window.__lenis?.scrollTo("#services", { offset: -56, duration: 1.4 })}
          className="group flex items-center gap-1 text-sm font-normal text-[#0066cc] transition-colors duration-200 hover:underline"
        >
          Explore services
          <ChevronRight size={16} className="transition-transform duration-200 group-hover:translate-x-0.5" />
        </button>
      </motion.div>
    </div>

    <motion.div
      initial={{ opacity: 0, y: 48 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
      className="mx-auto mt-16 max-w-6xl px-5 sm:mt-20 sm:px-6"
    >
      <div
        data-testid="hero-image-tile"
        className="overflow-hidden rounded-[28px] bg-[#f5f5f7] shadow-[0_24px_80px_-32px_rgba(0,0,0,0.25)]"
      >
        <img
          src="https://images.unsplash.com/photo-1630930678172-63343537a00a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6Nzh8MHwxfHNlYXJjaHw0fHx0YWlsb3IlMjBzZXdpbmclMjBtYWNoaW5lJTIwZ2FybWVudCUyMGZhYnJpYyUyMGNyYWZ0JTIwcHJlY2lzaW9ufGVufDB8fHx8MTc4OTA0NjYwNVww&ixlib=rb-4.1.0&q=85"
          alt="Precision sewing machine at work in the Meranggi workshop"
          className="aspect-[16/9] w-full object-cover sm:aspect-[21/9]"
        />
      </div>
    </motion.div>
  </section>
);
